import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { CustomEmptyState } from './CustomEmptyState';

export const EmptyStateDemoPage = () => {
  const resources = [
    // Core business
    'customers',
    'leads',
    'opportunities',
    'estimates',
    'invoices',
    'payments',
    'bills',

    // Operations
    'routes',
    'service-providers',
    'boards',

    // Driver management
    'drivers',
    'users',
    'driver-licenses',
    'driver-certifications',
    'driver-education',
    'driver-employment',
    'driver-vehicles',

    // Equipment management
    'equipment',
    'equipment-maintenance',
    'equipment-fuel',
    'equipment-inspections',
    'equipment-assignments',
    'equipment-incidents',

    // Forms and documentation
    'forms',
    'completed-forms',
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Empty State Demo
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        This page shows all the empty states for different resources.
      </Typography>

      <Grid container spacing={3}>
        {resources.map(resource => (
          <Grid item xs={12} md={6} lg={4} key={resource}>
            <Paper
              elevation={2}
              sx={{
                height: '400px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  p: 2,
                  backgroundColor: 'primary.main',
                  color: 'white',
                }}
              >
                <Typography variant="h6" component="h2">
                  {resource.charAt(0).toUpperCase() + resource.slice(1).replace('-', ' ')}
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <CustomEmptyState
                  resource={resource}
                  showBackground={false}
                  onAction={() => console.log(`Create ${resource} clicked`)}
                />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
